const mixin = {
  data() {
    return {

    };
  },
  methods:{
      switchFun(comm,data,activeNum){
          this.$router.push(`/ServiceSupport/${comm}`)
        //     let obj={
        //         cloudBox:cloudBox,
        //         printing:printing,
        //         issueSolving:issueSolving,
        //         scene:scene
        //     }
        // this.commView=obj[comm]
        if(data){
            sessionStorage.setItem("data",JSON.stringify(data))
        }
        if(activeNum!=undefined){
            sessionStorage.setItem("activeNum",activeNum)
        }
      }
  },
  filters: {
  },
};

export default mixin;



// WEBPACK FOOTER //
// ./src/components/comm/mixin.js